import * as Sentry from '@sentry/react';
import { isDevBuild } from '../environment';

export function setUser(user: { uid: string } | null) {
	if (isDevBuild()) {
		return;
	}
	Sentry.setUser(
		user && {
			id: user.uid,
		},
	);
}
